import { AppRouter } from './AppRouter'
import { AuthProvider } from '@/contexts/AuthContext.tsx'
import { LanguageProvider } from '@/contexts/LanguageContext'
import { MediaDevicesProvider } from '@/contexts/MediaDevicesContext'

export function App() {
  return (
    <LanguageProvider>
      <MediaDevicesProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </MediaDevicesProvider>
    </LanguageProvider>
  )
}
